import {
    WarningTwoTone,
} from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import './NoSchedulesAvailable.scss';

function NoSchedulesAvailable() {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'employee.dashboard' });
    return (
        <div className="noAvailableScheduleWarningBox">
            <WarningTwoTone
                className="noAvailableScheduleWarningIcon"
                color="error"
            />
            <span
                className="noAvailableScheduleWarningText"
            >
                {t('noneAvailable')}
            </span>
        </div>
    );
}

export default NoSchedulesAvailable;
